import { Button, Modal, ModalContent } from "semantic-ui-react";
import { APICall } from "../../api_helper";
import {
  NewModalTriggerComponent,
  NewModalTriggerComponentProps,
} from "./modal_triggers/NewModalTriggerComponent";
import {
  NewNewFormComponent,
  NewNewFormComponentProps,
} from "../new_form/NewNewFormComponent";
import React from "react";
import { getEventMetadata, getSession, useMutationWrapper } from "../../helper";

export const NewNewModalWithFormComponent = (props: {
  props: NewNewModalWithFormComponentProps;
}) => {
  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState<any>(
    props.props.formComponentProps.startingData,
  );
  const [mutation] = useMutationWrapper(
    props.props.apiCall.documentNode,
    (data) => {
      props.props.callback(data[props.props.apiCall.key]);
      setOpen(false);
    },
  );

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      // The modal renders in a portal, but React still bubbles events up the
      // component tree. When triggered from a Dropdown (card dot menu), the
      // Dropdown's keydown handler would preventDefault on Space/Enter.
      onKeyDown={(e: React.KeyboardEvent) => e.stopPropagation()}
      trigger={
        <NewModalTriggerComponent
          props={props.props.triggerProps}
          setOpen={setOpen}
        />
      }
    >
      <Modal.Header>{props.props.header}</Modal.Header>
      <ModalContent>
        <NewNewFormComponent
          props={props.props.formComponentProps}
          data={data}
          setData={setData}
        />
      </ModalContent>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)}>Cancel</Button>
        <Button
          positive
          onClick={() => {
            mutation({
              variables: {
                ...props.props.formComponentProps.getData(data),
                eventMetadata: getEventMetadata(),
                session: getSession(),
              },
            });
          }}
          disabled={!props.props.formComponentProps.isFormCompleted(data)}
        >
          Submit
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export type NewNewModalWithFormComponentProps = {
  header: string;
  triggerProps: NewModalTriggerComponentProps;
  formComponentProps: NewNewFormComponentProps;
  apiCall: APICall;
  callback: (data: any) => void;
};
